import { createApp } from 'vue'
import App from './App.vue'
import Emitter from 'tiny-emitter';
import store from './store';
import { library } from '@fortawesome/fontawesome-svg-core'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(far, fas, fab);

const app = createApp(App);

// TODO: consider a module to handle this (aka service or composable)
// TODO: perhaps ... useMSAL
app.config.globalProperties.$msalInstance = {};
// TODO: make the emitter a service
app.config.globalProperties.$emitter = new Emitter();

// app.component(Icon.name, Icon)
app.component('fa-icon', FontAwesomeIcon)
app.use(store).mount('#app');
